/** Normalize Puck page JSON for @measured/puck (content must be an array). */
export function normalizePuckStructure(structure) {
  if (!structure || typeof structure !== "object") {
    return { content: [], root: {}, zones: {} };
  }
  let content = structure.content;
  if (Array.isArray(content)) {
    content = content;
  } else if (content && typeof content === "object") {
    content = Object.values(content);
  } else {
    content = [];
  }

  const zones = structure.zones && typeof structure.zones === "object" ? structure.zones : {};
  const normalizedZones = {};
  Object.keys(zones).forEach((zoneKey) => {
    const zoneVal = zones[zoneKey];
    if (Array.isArray(zoneVal)) {
      normalizedZones[zoneKey] = zoneVal;
    } else if (zoneVal && typeof zoneVal === "object") {
      normalizedZones[zoneKey] = Object.values(zoneVal);
    } else {
      normalizedZones[zoneKey] = [];
    }
  });

  return {
    content,
    root: structure.root && typeof structure.root === "object" ? structure.root : {},
    zones: normalizedZones,
  };
}
